import {createStore, applyMiddleware, compose, Store} from 'redux';
import reducers from './reducers';
import createSagaMiddleware from 'redux-saga';
import saga from '../saga';

// @ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = createSagaMiddleware();

export default function (initState?: any): Store {
    // @ts-ignore
    // eslint-disable-next-line new-cap
    const store = createStore(reducers, initState ,composeEnhancers(
        applyMiddleware(middleware)
    ));
    middleware.run(saga);
    return store;
}
